//----------------------------------------
// multiple-choices.js
// Author: @reaganchisholm (Studio123)
//----------------------------------------

$('button[data-choice-button]').on('click', function () {
    var button = $(this);
    var contentNum = $(button).data('choice-button');
    showChoiceContent(button, contentNum);
})

function showChoiceContent(button, contentNum) {
    // Find our divs relative to the button clicked just incase there are multiple choice blocks on the page
    var allButtons = $(button).parents('.block--multiple-choices').find('.choice-buttons button');
    var contentDivs = $(button).parents('.block--multiple-choices').find('.choice-content');
    var newContentDiv = $(button).parents('.block--multiple-choices').find(`.choice-content[data-choice-content="${contentNum}"]`);
    var clickedSameButton = false;

    if ($(button).hasClass('is-active')) { clickedSameButton = true; };

    $(contentDivs).removeClass('is-active');
    $(allButtons).removeClass('is-active');

    var offset = $('.main-section.active .head').height() + 10;


    if (clickedSameButton === true) {
        // If our button is already active, clear focus and return
        $(button).blur();
        return;
    } else {
        // Otherwise, continue and add our classes
        $(button).addClass('is-active');
        $(newContentDiv).addClass('is-active');

        // If we show a content div, scroll to the top of the wrapper
        anime({
            targets: "html, body",
            scrollTop: $(button).parents('.block--multiple-choices').find('.choice-buttons').offset().top - offset,
            easing: 'easeInOutSine',
            duration: 400,
        });
    }
}
